/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onUpdateDocumentAnalysis = /* GraphQL */ `
  subscription OnUpdateDocumentAnalysis($entityId: ID!) {
    onUpdateDocumentAnalysis(entityId: $entityId) {
      id
      entityId
      firmId
      fileKey
      documents {
        identityId
        key
        level
        type
        name
      }
      status
      expenseStatus
      queryStatus
      matchedBiller {
        billerCode
        billerCategory
        shortName
        longName
        type
        industryCode
        industryCodeDescription
        createdAt
        updatedAt
      }
      matchedContactId
      matchedContact {
        id
        entityId
        xeroTenantId
        entityType
        firstName
        lastName
        email
        mobile
        phone
        taxNumber
        companyNumber
        name
        legalName
        searchName
        status
        website
        createdAt
        updatedAt
        contactType
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
        invalidFields
        bulkUploadFileKey
        owner
        createdBy
        beneficiaryBankId
        beneficiaryBpayId
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        postal {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        payoutErrors
      }
      matchedEntityId
      matchedEntity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      newContact {
        firstName
        lastName
        email
        mobile
        phone
        name
        taxNumber
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
      }
      task {
        reference
        dueAt
        issuedAt
        lodgementAt
        paymentAt
        gstInclusive
        notes
        amount
        gstAmount
        taxAmount
        lineItems {
          description
          quantity
          unitPrice
          price
          productCode
          taxType
        }
        numberOfPayments
        paymentFrequency
        shippingAmount
        settlementStatus
        partnerId
        managerId
        documentType
        subCategory
        category
        period
        year
      }
      bpay {
        billerCode
        referenceNumber
      }
      bank {
        accountNumber
        routingNumber
      }
      category
      source
      isCorrect
      fromEmail
      textContent
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateEntity = /* GraphQL */ `
  subscription OnUpdateEntity($entityId: ID!) {
    onUpdateEntity(entityId: $entityId) {
      id
      type
      taxNumber
      companyNumber
      billerCode
      name
      legalName
      businessNames
      searchName
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      logo {
        alt
        identityId
        key
        level
        type
      }
      brandColour
      website
      entityUsers {
        items {
          id
          entityId
          userId
          firmId
          email
          invitedEmail
          ocrEmail
          referredBy
          invitedEntityId
          firmEntityId
          providerContactId
          ownerCode
          clientGroupCode
          clientCode
          firstName
          lastName
          role
          jobTags
          paymentsEnabled
          termsInvoiceAccepted
          termsOcrAccepted
          termsFirmPayTaxAccepted
          termsFirmPayTaxDetails {
            document {
              identityId
              key
              level
              type
              name
            }
            acceptedAt
            email
            ip
            fullName
            firmId
          }
          entitySearchName
          entity {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          firm {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          searchName
          taxNumber
          taskSendSMS
          companyNumber
          createdBy
          createdAt
          updatedAt
          status
          partnerId
          managerId
          archivedAt
          taxPaymentReferences {
            itr {
              referenceNumber
              updatedAt
            }
            other {
              referenceNumber
              updatedAt
            }
          }
        }
        nextToken
      }
      gstRegistered
      gstReportingPeriod
      providerEntityId
      providerCompanyId
      providerBillUserCompanyId
      providerBankAccountId
      providerDigitalWalletId
      providerBpayCrn
      contact {
        firstName
        lastName
        email
        phone
        role
      }
      paymentMethods {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      paymentMethodId
      paymentUserId
      disbursementMethodId
      receivingAccounts {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      ubosCreated
      numUbosCreated
      subCategory
      clientsStatus
      ocrEmail
      termsInvoiceAccepted
      termsOcrAccepted
      owner
      referredBy
      connectedAccount
      accountStatus
      customerId
      xeroSyncStatus
      xeroLastContactSyncAt
      xeroContactSyncStatus
      xeroInvoiceSyncStatus
      xeroLastInvoiceSyncAt
      xeroTenantId
      absorbFees
      subscriptionTier
      invitationStatus
      clientsOnboardingStatus
      createdBy
      createdByEntityId
      isFirm
      createdAt
      updatedAt
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification {
    onCreateNotification {
      id
      title
      message
      status
      createdAt
      updatedAt
      type
      owner
    }
  }
`;
